export default __webpack_public_path__ + "static/home_slider1.png";